import {useIntl} from 'react-intl'
import {NumericFormat} from 'react-number-format'

import Select from 'react-select'
import {useGetStatement} from '../context/useStatement'
import {useStatement} from '../hook'
import moment from 'moment'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'

export default function Statement() {
  useGetStatement()

  const intl = useIntl()
  const {list, listFilter, listFilterSet} = useStatement()
  const currentDate = moment().format('MMMM YYYY')
  const tooltip1 = (
    <Tooltip id='tooltip1'>{intl.formatMessage({id: 'STATEMENT.PAYMENT_TABLE.INFO_1'})}</Tooltip>
  )

  const tooltip2 = (
    <Tooltip id='tooltip2'> {intl.formatMessage({id: 'STATEMENT.PAYMENT_TABLE.INFO_2'})}</Tooltip>
  )

  const tooltip3 = (
    <Tooltip id='tooltip3'> {intl.formatMessage({id: 'STATEMENT.PAYMENT_TABLE.INFO_3'})}</Tooltip>
  )

  const periods = [
    {
      value: '1-05-2024',
      periodType: 1,
      periodMounth: 9,
      periodYear: 2024,
      // label: 'May 2024',
      label: intl.formatMessage({id: 'STATEMENT.MAY_2024'}),
    },
    {
      value: '2-1-null',
      periodType: 2,
      periodMounth: 1,
      periodYear: null,
      // label: 'Last 1 Months',
      label: intl.formatMessage({id: 'STATEMENT.LAST_1_MONTHS'}),
    },
    {
      value: '2-null-1',
      periodType: 2,
      periodMounth: null,
      periodYear: 1,
      // label: 'Last 1 Year',
      label: intl.formatMessage({id: 'STATEMENT.LAST_1_YEAR'}),
    },
    {
      value: '3-null-null',
      periodType: 3,
      periodMounth: null,
      periodYear: null,
      // label: 'This Year',
      label: intl.formatMessage({id: 'STATEMENT.THIS_YEAR'}),
    },
  ]

  const key = `${listFilter.periodType || 'null'}-${listFilter.periodMounth || 'null'}-${
    listFilter.periodYear || 'null'
  }`
  const value = periods.find((item) => item.value === key)

  return (
    <>
      <div className='mt-10'>
        <div className='pt-10 min-h-800px'>
          <div className='row'>
            <div className='col col-md-2'>
              <div className='row'>
                <span className='fw-bold'>
                  {intl.formatMessage({id: 'STATEMENT.MERCHANT_SINCE'})}
                </span>
                <span className=''>{currentDate}</span>
              </div>
              <div className='row mt-10'>
                <span className='fw-bold mb-3'>
                  {intl.formatMessage({id: 'STATEMENT.MERCHANT_SINCE_DESC'})}
                </span>

                <Select
                  placeholder={intl.formatMessage({id: 'STATEMENT.SELECT_PERIOD'})}
                  className='custom-select'
                  options={periods}
                  value={value}
                  onChange={(value) => {
                    listFilterSet({
                      periodType: value?.periodType ?? 0,
                      periodMounth: value?.periodMounth ?? 0,
                      periodYear: value?.periodYear ?? 0,
                    })
                  }}
                />
              </div>
            </div>

            <div className='col col-md-10 mt-10 mt-md-0'>
              <div
                className='table-container'
                style={{maxHeight: '800px', overflowY: 'auto', width: '100%'}}
              >
                <table
                  id='kt_datatable_zero_configuration'
                  className='table table-responsive table-bordered table-striped gy-5'
                >
                  <thead className='bg-gray-200 ps-2'>
                    <tr className='fw-semibold fs-6 '>
                      <th>
                        {intl.formatMessage({id: 'STATEMENT.PAYMENT_TABLE.PAYMENT_TYPE'})}
                        <OverlayTrigger
                          placement='left'
                          overlay={
                            <Tooltip id='tooltip1'>
                              {/* Displays the payment types made by customer. According to the payment
                              type, the commissions are calculated. The payment types are, cash,
                              debit/credit card, flex card, point redemption, coupon redemption, 3rd
                              party coupon redemption, sales fee, monthly loyalty management fee. */}
                              {intl.formatMessage({
                                id: 'STATEMENT.PAYMENT_TABLE.PAYMENT_TYPE_INFO',
                              })}
                            </Tooltip>
                          }
                        >
                          <i className='bi bi-info-circle text-primary ms-1'></i>
                        </OverlayTrigger>
                      </th>

                      <th className='text-center'>
                        {intl.formatMessage({id: 'STATEMENT.PAYMENT_TABLE.TOTAL_SALES'})}
                        <OverlayTrigger
                          placement='left'
                          overlay={
                            <Tooltip id='tooltip1'>
                              {/* Displays the total sales amount made by loyalty members within the
                              selected period. */}
                              {intl.formatMessage({id: 'STATEMENT.PAYMENT_TABLE.TOTAL_SALES_INFO'})}
                            </Tooltip>
                          }
                        >
                          <i className='bi bi-info-circle text-primary ms-1'></i>
                        </OverlayTrigger>
                      </th>
                      <th className='text-center'>
                        {intl.formatMessage({id: 'STATEMENT.PAYMENT_TABLE.OF_TRX'})}
                        <OverlayTrigger
                          placement='left'
                          overlay={
                            <Tooltip id='tooltip1'>
                              {/* Displays the total orders placed by loyalty members within the
                              selected period. */}
                              {intl.formatMessage({id: 'STATEMENT.PAYMENT_TABLE.OF_TRX_INFO'})}
                            </Tooltip>
                          }
                        >
                          <i className='bi bi-info-circle text-primary ms-1'></i>
                        </OverlayTrigger>
                      </th>
                      <th className='text-center'>
                        {/* Transaction Count Fee ($) */}
                        {intl.formatMessage({id: 'STATEMENT.TRANSACTION_COUNT_FEE'})}
                        <OverlayTrigger
                          placement='left'
                          overlay={
                            <Tooltip id='tooltip1'>
                              {/* Displays the commission fee per transaction, calculated based on the
                              number of transactions made within the selected period.{' '} */}
                              {intl.formatMessage({id: 'STATEMENT.TRANSACTION_COUNT_FEE_INFO'})}
                            </Tooltip>
                          }
                        >
                          <i className='bi bi-info-circle text-primary ms-1'></i>
                        </OverlayTrigger>
                      </th>
                      <th className='text-center'>
                        {/* Fee per Transaction ($) */}
                        {intl.formatMessage({id: 'STATEMENT.FEE_PER_TRANSACTION'})}
                        <OverlayTrigger
                          placement='left'
                          overlay={
                            <Tooltip id='tooltip'>
                              {/* Displays the commission fee calculated according to the total
                              transaction amount within the selected period. */}
                              {intl.formatMessage({id: 'STATEMENT.FEE_PER_TRANSACTION_INFO'})}
                            </Tooltip>
                          }
                        >
                          <i className='bi bi-info-circle text-primary ms-1'></i>
                        </OverlayTrigger>
                      </th>
                      <th className='text-center'>
                        {/* Total Commission Fee ($) */}
                        {intl.formatMessage({id: 'STATEMENT.TOTAL_COMMISSION_FEE'})}
                        <OverlayTrigger
                          placement='left'
                          overlay={
                            <Tooltip id='tooltip2'>
                              {/* Indicates the overall commission amount paid or to be paid by the
                              merchant within the selected period.{' '} */}
                              {intl.formatMessage({id: 'STATEMENT.TOTAL_COMMISSION_FEE_INFO'})}
                            </Tooltip>
                          }
                        >
                          <i className='bi bi-info-circle text-primary ms-1'></i>
                        </OverlayTrigger>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {list.dataList.map((item, index) => (
                      <tr key={index}>
                        <td>
                          {item.paymentTypeName}

                          {item.paymentTypeName === 'Point Redemption' && (
                            <OverlayTrigger placement='left' overlay={tooltip3}>
                              <i className='bi bi-info-circle text-primary ms-1'></i>
                            </OverlayTrigger>
                          )}
                        </td>
                        <td className='text-center'>
                          <NumericFormat
                            value={item.totalSalesAmount?.toFixed(2)}
                            displayType={'text'}
                            thousandSeparator={true}
                          />
                        </td>
                        <td className='text-center'>{item.numberOfTransaction}</td>
                        <td className='text-center'>{item.commission}</td>
                        <td className='text-center'>
                          <NumericFormat
                            value={item.commissionFee?.toFixed(2)}
                            displayType={'text'}
                            thousandSeparator={true}
                          />
                        </td>
                        <td className='text-center'>
                          <NumericFormat
                            value={item.totalDue?.toFixed(2)}
                            displayType={'text'}
                            thousandSeparator={true}
                          />
                        </td>
                      </tr>
                    ))}

                    {/* <tr>
                      <td>{intl.formatMessage({ id: 'STATEMENT.PAYMENT_TABLE.CASH' })}</td>
                      <td className='text-center'>1,000.00</td>
                      <td className='text-center'>100</td>
                      <td className='text-center'>0.10%</td>
                      <td className='text-center'>0.01</td>
                      <td className='text-center'>2</td>
                    </tr>
                    <tr>
                      <td>{intl.formatMessage({ id: 'STATEMENT.PAYMENT_TABLE.DEBIT_CREDIT_CARD' })}</td>
                      <td className='text-center'>1,000.00</td>
                      <td className='text-center'>100</td>
                      <td className='text-center'>2.50%</td>
                      <td className='text-center'>0.00</td>
                      <td className='text-center'>25.00</td>
                    </tr>
                    <tr>
                      <td>{intl.formatMessage({ id: 'STATEMENT.PAYMENT_TABLE.FLEX_CARD' })}</td>
                      <td className='text-center'>1,000.00</td>
                      <td className='text-center'>100</td>
                      <td className='text-center'>1.50%</td>
                      <td className='text-center'>0.05</td>
                      <td className='text-center'>20.00</td>
                    </tr>
                    <tr>
                      <td>{intl.formatMessage({ id: 'STATEMENT.PAYMENT_TABLE.POINTS_REDEMTION' })}
                        <span className='text-danger'>³</span>
                      </td>
                      <td className='text-center'>100.00</td>
                      <td className='text-center'>10</td>
                      <td className='text-center'>2.50%</td>
                      <td className='text-center'>0.00</td>
                      <td className='text-center'>2.50</td>
                    </tr>
                    <tr>
                      <td>{intl.formatMessage({ id: 'STATEMENT.PAYMENT_TABLE.OWN_COUPON_REDEMTION' })}</td>
                      <td className='text-center'>100.00</td>
                      <td className='text-center'>20</td>
                      <td className='text-center'>2.50%</td>
                      <td className='text-center'>0.00</td>
                      <td className='text-center'>2.50</td>
                    </tr>
                    <tr>
                      <td>{intl.formatMessage({ id: 'STATEMENT.PAYMENT_TABLE.3RD_COPOUN_REDEMTION' })}</td>
                      <td className='text-center'>100.00</td>
                      <td className='text-center'>20</td>
                      <td className='text-center'>2.50%</td>
                      <td className='text-center'>0.00</td>
                      <td className='text-center'>2.50</td>
                    </tr>
                    <tr className='fw-bold'>
                      <td>{intl.formatMessage({ id: 'STATEMENT.PAYMENT_TABLE.SALES_FEE_TOTAL' })}</td>
                      <td className='text-center'>3,300.00</td>
                      <td className='text-center'>350.00</td>
                      <td className='text-center'></td>
                      <td className='text-center'></td>
                      <td className='text-center'>54.50</td>
                    </tr>
                    <tr>
                      <td>{intl.formatMessage({ id: 'STATEMENT.PAYMENT_TABLE.MONTLY_LOYALTY_MNGMT' })}</td>
                      <td className='text-center'></td>
                      <td className='text-center'></td>
                      <td className='text-center'>-</td>
                      <td className='text-center'>20.00</td>
                      <td className='text-center'>20.00</td>
                    </tr>
                    <tr className='fw-bold'>
                      <td>{intl.formatMessage({ id: 'STATEMENT.PAYMENT_TABLE.TOTAL_DUE' })}</td>
                      <td className='text-center'></td>
                      <td className='text-center'></td>
                      <td className='text-center'></td>
                      <td className='text-center'></td>
                      <td className='text-center'>74.50</td>
                    </tr> */}
                  </tbody>
                </table>
              </div>

              {/* <div
                className='table-container'
                style={{ maxHeight: '400px', overflowY: 'auto', width: '100%' }}
              >
                <table
                  id='kt_datatable_zero_configuration'
                  className='table table-bordered table-striped gy-5 mt-5'
                >
                  <thead className='bg-gray-200 ps-2'>
                    <tr className='fw-semibold fs-6'>
                      <th>Refund with</th>
                      <th className='text-center'>{intl.formatMessage({ id: 'STATEMENT.PAYMENT_TABLE.TOTAL_SALES' })}</th>
                      <th className='text-center'>{intl.formatMessage({ id: 'STATEMENT.PAYMENT_TABLE.OF_TRX' })}</th>
                      <th className='text-center'>
                        {intl.formatMessage({ id: 'STATEMENT.PAYMENT_TABLE.OF_TRX' })}<span className='text-danger'>¹</span>
                      </th>
                      <th className='text-center'>
                        {intl.formatMessage({ id: 'STATEMENT.PAYMENT_TABLE.FEE_TRX' })}<span className='text-danger'>²</span>
                      </th>
                      <th className='text-center'>{intl.formatMessage({ id: 'STATEMENT.PAYMENT_TABLE.TOTAL_DUE' })}</th>
                    </tr>
                  </thead>
                  <tbody className=''>
                    <tr>
                      <td>{intl.formatMessage({ id: 'STATEMENT.PAYMENT_TABLE.CASH' })}</td>
                      <td className='text-center'>100.00</td>
                      <td className='text-center'>10</td>
                      <td className='text-center'>0.00%</td>
                      <td className='text-center'>0.01</td>
                      <td className='text-center'>0.10</td>
                    </tr>
                    <tr>
                      <td>{intl.formatMessage({ id: 'STATEMENT.PAYMENT_TABLE.DEBIT_CREDIT_CARD' })}</td>
                      <td className='text-center'>100.00</td>
                      <td className='text-center'>10</td>
                      <td className='text-center'>0.00%</td>
                      <td className='text-center'>0.01</td>
                      <td className='text-center'>0.10</td>
                    </tr>
                    <tr>
                      <td>{intl.formatMessage({ id: 'STATEMENT.PAYMENT_TABLE.FLEX_CARD' })}</td>
                      <td className='text-center'>100.00</td>
                      <td className='text-center'>10</td>
                      <td className='text-center'>0.00%</td>
                      <td className='text-center'>0.01</td>
                      <td className='text-center'>0.10</td>
                    </tr>
                    <tr>
                      <td>{intl.formatMessage({ id: 'STATEMENT.PAYMENT_TABLE.POINT_REFUNDED' })}</td>
                      <td className='text-center'>10.00</td>
                      <td className='text-center'>1</td>
                      <td className='text-center'>0.00%</td>
                      <td className='text-center'>0.01</td>
                      <td className='text-center'>0.01</td>
                    </tr>
                    <tr className='fw-bold'>
                      <td>{intl.formatMessage({ id: 'STATEMENT.PAYMENT_TABLE.TOTAL_DUE' })}</td>
                      <td className='text-center'></td>
                      <td className='text-center'></td>
                      <td className='text-center'></td>
                      <td className='text-center'></td>
                      <td className='text-center'>0.11</td>
                    </tr>
                  </tbody>
                </table>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
